import { Controller } from "@hotwired/stimulus";
import { i18n } from "../../utils/i18n";
import {
  createConfirmationModal,
  closeModal,
  showModal
} from "../../utils/modals";

export default class extends Controller {
  static values = {
    modelName: String,
    selectedItems: Array
  };

  modal;

  open(e) {
    e.preventDefault();

    const count = this.selectedItemsValue.length;

    const title = i18n.t("list_table.delete_confirmation_title");
    const translatedModelName = i18n.t(this.modelNameValue, {
      scope: "activerecord.models",
      count
    });

    const resources = i18n.t("selected", {
      scope: `list_table.${this.modelNameValue}`,
      count,
      model_name: translatedModelName,
      defaultValue: i18n.t("selected", { scope: "list_table" })
    });

    const content = i18n.t("list_table.delete_confirmation", {
      count,
      record: count == 1 ? resources : `${count} ${resources}`
    });

    const onConfirm = (() => {
      this.element.form
        .querySelectorAll('[name="ids[]"]')
        .forEach((e) => e.remove());
      closeModal(this.modal);
      this.selectedItemsValue.forEach((item) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = "ids[]";
        input.value = item;
        this.element.form.appendChild(input);
      });
      this.element.form.requestSubmit();
    }).bind(this);

    this.modal = createConfirmationModal({
      title,
      content,
      okButton: i18n.t("actions.delete"),
      okButtonClass: "btn_danger",
      onConfirm
    });

    showModal(this.modal);

    this.modal.addEventListener("click", (event) => {
      if (this.modal.dataset.staticBackdrop !== undefined) return;
      if (this.modal !== event.target) return;
      closeModal(this.modal);
    });
  }
}
